import { UploadedFile } from "@cca/components";
import { useServiceProvider } from "@providers";
import { LearnerResponseFileService } from "@services";
import { useMutation } from "@tanstack/react-query";

type UseDeleteLearnerFileProviderParam = {
  id: number;
};

type UseSaveLearnerFileResponseParam = {
  file: UploadedFile;
  fileKind: string;
  onProgress?: (progress: number) => void;
};

export function useLearnerFileProvider() {
  const { initialization: learnerResponseFileServiceInit } = useServiceProvider(
    LearnerResponseFileService,
  );

  const saveFileMutation = useMutation({
    mutationFn: async ({
      file,
      fileKind,
      onProgress,
    }: UseSaveLearnerFileResponseParam) => {
      const { service } = await learnerResponseFileServiceInit;
      return service.saveFile(file, fileKind, onProgress);
    },
  });

  const deleteFileMutation = useMutation({
    mutationFn: async ({ id }: UseDeleteLearnerFileProviderParam) => {
      const { service } = await learnerResponseFileServiceInit;
      return service.deleteFile(id);
    },
  });

  return {
    getFile: async (
      ...args: Parameters<LearnerResponseFileService["downloadFile"]>
    ) => {
      const { service } = await learnerResponseFileServiceInit;
      return service.downloadFile(...args);
    },
    saveFile: saveFileMutation.mutateAsync,
    deleteFile: deleteFileMutation.mutateAsync,
  };
}
